/* Боковая панель слева, раздел справа. На телефоне панель — полоса сверху. */
.shell {
  display: flex;
  height: 100%;
  overflow: hidden;
}

/* Прокручивается только содержимое раздела: панель остаётся на месте,
   иначе при длинных таблицах она уезжала бы за край. */
.content {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@media (max-width: 699px) {
  .shell { flex-direction: column; }
}
